import { useEffect, useState } from "react";
import { CONTENT } from "@/content";
import { useApi } from "@/lib/api";

const R = CONTENT.admin.ripples;
const NAMES = Object.fromEntries(CONTENT.share.platforms);

export const Ripples = () => {
  const api = useApi();
  const [d, setD] = useState(null);
  useEffect(() => { api("get", "/admin/ripples").then(setD).catch(() => {}); }, [api]);
  if (!d) return null;
  return (
    <div className="admin-stack" data-testid="admin-ripples">
      <h2 className="admin-h2">{R.title}</h2>
      <div className="form-grid">
        <div className="nb-card stat-card" data-testid="ripples-total-shares"><span className="stat-num">{d.total_shares}</span><span className="field-label">{R.totalShares}</span></div>
        <div className="nb-card stat-card" data-testid="ripples-total-reached"><span className="stat-num">{d.total_reached}</span><span className="field-label">{R.totalReached}</span></div>
      </div>
      <div className="nb-card admin-stack">
        <h3 className="row-title">{R.byPlatform}</h3>
        {d.by_platform.length ? d.by_platform.map((p) => <p key={p.platform} className="row-ref">{NAMES[p.platform]}: {p.shares}</p>) : <p className="muted">{R.none}</p>}
      </div>
      <div className="nb-card admin-stack">
        <h3 className="row-title">{R.top}</h3>
        {d.top.length ? <ol className="top-list">{d.top.map((t, i) => <li key={i} className="row-ref">{t.title} ({t.reference}): {t.shares}</li>)}</ol> : <p className="muted">{R.none}</p>}
      </div>
    </div>
  );
};
